import styles from "./SubsidyDetails.module.css";
import heartIcon from "../../assets/icons/heart.svg";
import { useContext } from "react";
import { AppContext } from "../../state";
import { SubsidyIndividualWarning } from "./SubsidyIndividualWarning.tsx";
import { useI18n } from "../../i18n";

interface SubsisdyDetailsProps {
  subsidyBoxClickHandler: () => void;
}

const SubsidyDetails = (props: SubsisdyDetailsProps) => {
  const { t, locale, formatNumber } = useI18n();
  const state = useContext(AppContext);

  const calculationDetails = state.calculation.calculationDetails?.calculationDetailsWithSubsidy;
  const leasingDuration = state.configuration.frameContract.leasing_company_id.leasing_duration;
  const subsidyBrutto = calculationDetails?.subsidyGrossResolved;
  const subsidyNet = calculationDetails?.subsidyNet;

  if (calculationDetails?.subsidyType === "individual" && calculationDetails?.subsidyGrossResolved === 0) {
    return <SubsidyIndividualWarning subsidyBoxClickHandler={props.subsidyBoxClickHandler} />;
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <img src={heartIcon} alt={"heart icon"} className={styles.icon} />
        <span className={styles.title}>{t("savings.subsidy.header")}</span>
      </div>
      <div className={styles.details}>
        <p>
          {t("savings.subsidy.leasingPeriodBrutto", {
            brutto: subsidyBrutto && formatNumber(subsidyBrutto),
            currency: locale.currencySymbol,
            duration: leasingDuration,
            total: subsidyBrutto && calculationDetails.subsidyGrossTotal,
          })}
          <strong>{t("savings.subsidy.result")}</strong>
          <br />
          {t("savings.subsidy.leasingPeriodNetto", {
            netto: subsidyNet && formatNumber(subsidyNet),
            currency: locale.currencySymbol,
            duration: leasingDuration,
            total: subsidyNet && calculationDetails.subsidyNetTotal,
          })}
        </p>
        <p>
          <strong>{t("savings.subsidy.finalSavings")}</strong>
          {t("savings.subsidy.message")}
        </p>
      </div>
    </div>
  );
};

export { SubsidyDetails };
